"use client";

import { createContext, Dispatch, ReactNode, SetStateAction } from "react";

import { useSignInModal } from "@/components/modals//sign-in-modal";

export const ModalContext = createContext<{
  setShowSignInModal: Dispatch<SetStateAction<boolean>>;
  setShowFreeTrialMessage: Dispatch<SetStateAction<boolean>>;
}>({
  setShowSignInModal: () => {},
  setShowFreeTrialMessage: () => {},
});

export default function ModalProvider({ children }: { children: ReactNode }) {
  const { SignInModal, setShowSignInModal, setShowFreeTrialMessage } = useSignInModal();

  return (
    <ModalContext.Provider
      value={{
        setShowSignInModal,
        setShowFreeTrialMessage,
      }}
    >
      <SignInModal />
      {children}
    </ModalContext.Provider>
  );
}
